<template> 
  <div v-if="item.length!==0"> 
    <div  
      v-for="(temp,index) in item"
      :key="index"
    >  
      <v-card
        flat
        class="my-2"
      >
        <v-row no-gutters> 
          <v-col
            cols="3"
            sm="2"
            :class="index === 0 ? 'roundColor' : 'roundColorPrevious'"
          >
            <v-container 
              fluid 
              fill-height 
              :class="index === 0 ? 'roundColor' : 'roundColorPrevious'"
            >
              <v-row
                no-gutters
                class="text-center white--text"
              > 
                <v-col cols="12">
                  <h2>{{ dateConvert(temp.created_at).getDate() }}</h2>
                </v-col>
                <v-col cols="12">
                  <h5>
                    {{ getShortMonth(dateConvert(temp.created_at).getMonth()) }}
                    {{ dateConvert(temp.created_at).getFullYear()+543 }}
                  </h5>
                </v-col>    
              </v-row>   
            </v-container> 
          </v-col> 
          <v-col  
            class="text-center"
            cols="9" 
            sm="10"
          >
            <v-row 
              no-gutters 
            >
              <v-col cols="12">
                <v-col cols="12">
                  <b class="grey--text">{{ $t('lotto-type.four-group') }}</b>
                </v-col>
                <v-col cols="12">
                  <b :class="index===0? 'orange--text' : ''">{{ temp.four ? temp.four : 'XXXX' }}</b>
                </v-col>
              </v-col> 
            </v-row>
          </v-col>
        </v-row>
      </v-card> 
    </div>
  </div>
</template>
<script>
import { dateConvert, getShortMonth } from '@/plugins/time'
export default {   
    props : {
        item : {
            type : Array,
            default : ()=>[]
        }
    },
    methods : {
      dateConvert ,
      getShortMonth 
    }
}
</script>
<style scoped>
.roundColor {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px; 
  background-color: var(--bg-secondary-color); 
}
.roundColorPrevious { 
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px; 
  background-color: var(--bg-main-color); 
}  
</style>